import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from '@ui/primitives/utils';
import { ArrowUp, MinusCircle } from 'lucide-react';
export const ModuleDependencyRenderer = (param)=>{
    let { value } = param;
    if (!value) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex h-full items-center",
            children: /*#__PURE__*/ _jsx(MinusCircle, {
                className: "h-5 w-5 text-muted-foreground"
            })
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('flex h-full items-center gap-2', value.type === 'up' || value.type === 'down' ? 'text-primary' : ''),
        children: [
            value.type === 'up' && /*#__PURE__*/ _jsx(ArrowUp, {
                className: "h-5 w-5"
            }),
            value.type === 'down' && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(ArrowUp, {
                        className: "h-5 w-5 rotate-180"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-base font-medium",
                        children: value.count
                    })
                ]
            })
        ]
    });
};
